import React from "react";

import styles from "./PreTextCell.module.scss";

export const PreTextContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.preTextContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
